import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyB_KUUReN4e19UO1vF1BJLJUVWMrQ_0hsY",
  authDomain: "mustakim-nur-salin.firebaseapp.com",
  databaseURL: "https://mustakim-nur-salin-default-rtdb.firebaseio.com",
  projectId: "mustakim-nur-salin",
  storageBucket: "mustakim-nur-salin.firebasestorage.app",
  messagingSenderId: "513682355733",
  appId: "1:513682355733:web:64698fb25599e09b88401c",
  measurementId: "G-S3LC92B7LY"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getDatabase(app);
export default app;
